import type { components } from '../../../types/schema';

type Paragraph = components['schemas']['ApiV1SceneEpisodeParagraph'];

interface EpisodeBlockProps {
  sceneEpisodeId: string;
  paragraphs: Paragraph[];
}

const EpisodeBlock = ({ paragraphs, sceneEpisodeId }: EpisodeBlockProps) => {
  if (paragraphs.length === 0) {
    return (
      <div className="px-[17px]">
        <p className="text-lg leading-relaxed text-text-main-lv2 dark:text-[#FFF]">
          이 에피소드에는 표시할 문단이 없습니다.
        </p>
      </div>
    );
  }

  return (
    <div className="px-[17px]">
      {paragraphs.map((paragraph) => {
        const tokens = (paragraph.content ?? '').split(/(\s+)/);
        let charOffset = 0;
        return (
          <p
            key={paragraph.sceneEpisodeParagraphId}
            data-scene-episode-id={sceneEpisodeId}
            data-paragraph-index={paragraph.paragraphIndex}
            data-content={paragraph.content}
            className="text-lg leading-relaxed text-text-main-lv2 dark:text-[#FFF] whitespace-pre-wrap"
            style={{
              fontFamily: '"Noto Serif KR", ui-serif, Georgia, "Times New Roman", serif'
            }}
          >
            {tokens.map((token, tokenOffset) => {
              const startOffset = charOffset;
              charOffset += token.length;
              return Array.from(token).map((ch, i) => (
                <span
                  key={`${paragraph.sceneEpisodeParagraphId}-w-${tokenOffset}-c-${i}`}
                  data-scene-episode-id={sceneEpisodeId}
                  data-paragraph-index={paragraph.paragraphIndex}
                  data-char-offset={startOffset + i}
                  data-reading-char="true"
                  className="leading-[40px]"
                >
                  {ch}
                </span>
              ));
            })}
          </p>
        );
      })}
    </div>
  );
};

export default EpisodeBlock;
